import { AuthPageLayout } from "./auth-page-layout";
import { Button, Icons } from "@/components/ui";

const MOCK_EMAIL = "alex@example.com";

export function RegisterSuccessPage() {
  return (
    <AuthPageLayout>
      <div
        className="flex flex-col items-center gap-5 text-center"
        data-testid="register-success"
      >
        <div className="flex h-16 w-16 items-center justify-center rounded-full border border-glass-stroke bg-glass-fill">
          <Icons.Mail className="h-7 w-7 text-accent" />
        </div>

        <h2 className="text-2xl font-semibold text-primary">
          Check your email
        </h2>

        <p className="text-[15px] leading-normal text-secondary">
          We&apos;ve sent a verification link to{" "}
          <span className="font-medium text-primary">{MOCK_EMAIL}</span>. Click
          the link to activate your account.
        </p>

        <Button
          variant="secondary"
          size="lg"
          onClick={() => console.log("[workshop] Navigate to login")}
          className="w-full liquid-glass-distortion shadow-glass border-glass-stroke-light font-semibold text-accent"
          data-testid="back-to-login"
        >
          Back to sign in
        </Button>
      </div>
    </AuthPageLayout>
  );
}
